import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import UiFormControlLabel from 'ui-components/ui-form-control-label/UiFormControlLabel';
import UiCheckbox from 'ui-components/ui-checkbox/UiCheckbox';
import { getCurrentSlice } from 'utils';
import { usePlatform } from 'hooks';
import { useTranslation } from 'react-i18next';
import { toast } from 'lib';

/**
 * فیلتر انتخاب بستر
 */
export const PlatformFilter = (props) => {
  const dispatch = useDispatch();
  const { getPlatforms } = usePlatform();
  const { componentName, parentPlatform, className } = props;
  const { t } = useTranslation();
  const filter = useSelector((state) =>
    parentPlatform
      ? state[state.filterReducer.filtersContext].filters[parentPlatform][
          componentName
        ]
      : state[state.filterReducer.filtersContext].filters[componentName]
  );
  const reducerName = useSelector(
    (state) => state.filterReducer.filtersContext
  );
  const { selectedIds } = filter;
  const { setSelectedFilterIds } = getCurrentSlice(reducerName);

  const platforms = getPlatforms()
    .filter((platform) => platform !== 'multiPlatform')
    .map((platform) => ({
      id: platform,
      title: t(`filter:${platform}`),
    }));

  const handleChangePlatform = (event, id) => {
    const isUncheckingLastPlatform =
      filter.selectedIds.length === 1 && !event.target.checked;
    if (isUncheckingLastPlatform) {
      toast({
        title: t('filter:requiredAtLeastOnePlatform'),
        type: 'error',
        autoClose: 2000,
      });
      return;
    }
    dispatch(
      setSelectedFilterIds({
        id,
        isChecked: event.target.checked,
        componentName,
        parentPlatform,
      })
    );
  };

  return (
    <div className={classNames('grid', className)}>
      {platforms.map(({ id, title }) => {
        return (
          <UiFormControlLabel
            key={id}
            className='mr-0'
            label={title}
            control={
              <UiCheckbox
                checked={selectedIds?.includes(id)}
                name={id}
                onChange={(event) => handleChangePlatform(event, id)}
              />
            }
          />
        );
      })}
    </div>
  );
};

PlatformFilter.propTypes = {
  componentName: PropTypes.string.isRequired,
  parentPlatform: PropTypes.string,
  className: PropTypes.string,
};
